import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { BankOpsApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  view_data: null,
  list_data: null
};

const BankSlice = createSlice({
  name: 'Bank',
  initialState,
  reducers: {
    setBankView(state, action) {
      state.view_data = action.payload;
    },
    setBankGrid(state, action) {
      state.list_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Bank Ops View
export const getBankViewData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: BankOpsApi?.bankOpsView,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setBankView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setBankView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Bank Ops View failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Ops View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Bank Ops List
export const getBankOpsList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: BankOpsApi?.bankOpsList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setBankGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setBankGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Bank Ops List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Ops List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setBankView, setBankGrid } = BankSlice.actions;
export default BankSlice.reducer;
